import * as React from 'react';
import * as free from './style.module.scss';
export const Free = ({ widgetFree }) => {
  return (
    <section className={free.free}>
      <div className={`container ${free.free__container}`}>
        <div className={free.free__info}>
          <h2 className={free.free__title} id="program-free">
            Попробуйте первое занятие <span className={free.free__titleOrange}>бесплатно</span>
          </h2>
          <ul className={free.free__list}>
            <li className={free.free__item}>
              <p>
                Вы узнаете, как привести мозг в тонус и подготовить его к продуктивной работе
              </p>
            </li>
            <li className={free.free__item}>
              <p>
                Познакомитесь с принципами визуального восприятия
              </p>
            </li>
            <li className={free.free__item}>
              <p>
                Примените эти знания на практике уже во время занятия
              </p>
            </li>
          </ul>
        </div>
        <div className={free.free__form}>
          { widgetFree }
        </div>
      </div>
    </section>
  );
};
